import React, { memo, useState } from 'react';
import { View, Image } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space, IconSend } from '@redlink/components/atoms';
import { SharePage } from '@redlink/components/pages';
import { HeaderTooltipTemplate } from '@redlink/components/templates';
import {
  DashboardHeaderUserInfo,
  Ads,
  Button,
  ToolTip,
  usePlan,
} from '@redlink/components/molecules';
import { useValues } from '@redlink/assets/values';
import { useLocale } from '@redlink/assets/locale';
import { useQuery, getPageProfileQuery } from '@redlink/services';

export const DashboardHeader = memo(({ navigation }) => {
  const { styles, colors } = useStyle();
  const { getPageLink } = useValues();
  const { dictionary, isRtl } = useLocale();
  const [shareIsVisible, setShareIsVisible] = useState(false);
  const { showPlanDialog } = usePlan();

  const {
    loading: getPageProfileIsBusy,
    data: { PageProfile: { pageName, fullname, avatar } = {} },
  } = useQuery(getPageProfileQuery);

  return (
    <>
      <View style={styles.container}>
        <View style={styles.headerLeftContainer}>
          <Image
            source={require('@redlink/assets/images/logo.png')}
            style={styles.logo}
          />
          {!getPageProfileIsBusy && (
            <>
              <Text en style={styles.text}>
                {getPageLink(pageName)}
              </Text>
              <Space />
              <Button
                onPress={() => setShareIsVisible(true)}
                variant="gray"
                icon={
                  <View
                    style={{
                      ...(!isRtl && { transform: [{ rotateY: '180deg' }] }),
                    }}
                  >
                    <IconSend color={colors.black} size={16} />
                  </View>
                }
                title={dictionary.share}
                style={styles.shareButton}
              />
            </>
          )}
        </View>
        {!getPageProfileIsBusy && (
          <View style={styles.headerRightContainer}>
            <ToolTip
              renderButton={() => (
                <DashboardHeaderUserInfo
                  title={fullname}
                  imageUrl={avatar?.thumbnailUrl}
                />
              )}
            >
              <HeaderTooltipTemplate onPlanPress={showPlanDialog} />
            </ToolTip>
          </View>
        )}
        <SharePage
          isVisible={shareIsVisible}
          onDismiss={() => setShareIsVisible(false)}
        />
      </View>
      <View style={styles.adsContainer}>
        <Ads onShowPlans={showPlanDialog} />
      </View>
    </>
  );
});

const useStyle = createUseStyle(({ colors, size, shadow, theme }) => ({
  container: {
    backgroundColor: colors.white,
    height: size.headerHeight,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 39,
    ...shadow.header,
  },
  logo: {
    width: 28,
    height: 34,
  },
  text: {
    fontSize: 26,
    color: colors.red1,
    marginStart: 20,
    paddingBottom: 4,
  },
  headerLeftContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerRightContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  signOutButton: {
    width: 48,
    height: 48,
  },
  adsContainer: {
    backgroundColor: colors.blue2,
    marginStart: size.drawerWidth,
  },
  shareButton: {
    borderRadius: 24,
    height: 36,
    padding: 10,
  },
}));
